import { render } from "./TrainingCharts.vue?vue&type=template&id=52c11537&scoped=true"
import script from "./TrainingCharts.vue?vue&type=script&lang=js"
export * from "./TrainingCharts.vue?vue&type=script&lang=js"

import "./TrainingCharts.vue?vue&type=style&index=0&id=52c11537&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c11537"]])

export default __exports__